import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AppRatingForm } from "@/components/AppRatingForm";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export function RatingPrompt() {
  const { user, refreshUser } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!user?.show_rating_prompt || window.location.pathname === "/app-reviews") return;
    const t = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(t);
  }, [user?.show_rating_prompt]);
  const close = async (submitted) => {
    setOpen(false);
    if (!submitted) await api.post("/app-reviews/dismiss").catch(() => {});
    refreshUser();
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close(false)}>
      <DialogContent data-testid="rating-prompt" className="bg-[#151C2C] border-[#26334D] text-white max-w-md">
        <DialogHeader>
          <DialogTitle>Enjoying VacaVibe?</DialogTitle>
          <DialogDescription className="text-slate-400">Rate the app from 1 to 5 stars. We only ask once.</DialogDescription>
        </DialogHeader>
        <AppRatingForm onDone={close} />
      </DialogContent>
    </Dialog>
  );
}
